<template>
  <div :class="{'spinner-container': true, 'small': small, 'inline': inline}">
    <div class="loader">
    </div>
  </div>
</template>

<style>
.spinner-container {
  height: 26px;
  margin: auto 0 auto 0;
}
.loader {
  border: 2px solid #e8e8e8;
  border-top: 2px solid #3498db;
  border-radius: 50%;
  width: 26px;
  height: 26px;
  animation: spin 0.75s linear infinite;
  margin: auto auto auto auto;
}

.spinner-container.small {
  height: 13px;
}
.spinner-container.small > .loader {
  width: 13px;
  height: 13px;
}

.spinner-container.inline {
  display: inline-block;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>

<script>
export default {
  name: 'Spinner',
  props: {
    small: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    }
  }
}
</script>